import * as React from "react";
const SvgFiRrParagraphLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M9 12h4v3a1 1 0 1 0 2 0V2h2v13a1 1 0 1 0 2 0V2h1a1 1 0 1 0 0-2H9C5.691 0 3 2.691 3 6s2.691 6 6 6M9 2h4v8H9c-2.206 0-4-1.794-4-4s1.794-4 4-4m14 17a1 1 0 0 1-1 1H3.653l2.165 2.317A1.002 1.002 0 0 1 5.086 24a1 1 0 0 1-.73-.317L1.94 21.097c-1.146-1.146-1.146-3.048.024-4.218l2.39-2.562a1.001 1.001 0 0 1 1.463 1.365l-2.163 2.317h18.347a1 1 0 0 1 1 1z"
    />
  </svg>
);
export default SvgFiRrParagraphLeft;
